import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryForm from './baseQueryForm';

const product = createApi({
    reducerPath: 'products',
    baseQuery: baseQueryForm,
    endpoints: (builder) => ({
        uploadImage: builder.mutation({
            query: (params) => {
                return {
                url: "products/uploadImage",
                method: "POST",
                body: params,
                };
            },
        }),
        getListProducts: builder.mutation({
            query: (param) => ({
                url: 'products/getListProducts',
                method: 'POST',
                body: param,
            }),
        }),
        getListProducts: builder.mutation({
            query: (param) => ({
                url: 'products/getListProducts',
                method: 'POST',
                body: param,
            }),
        }),
        saveImportKPI: builder.mutation({
            query: (param) => ({
                url: 'home/saveImportKPI',
                method: 'POST',
                body: param,
            }),
        }),
        saveImportSMS: builder.mutation({
            query: (param) => ({
                url: 'consumer/saveImportSMS',
                method: 'POST',
                body: param,
            }),
        }),
        saveImportStatus: builder.mutation({
            query: (param) => ({
                url: 'products/saveImportStatus',
                method: 'POST',
                body: param,
            }),
        }),
    }),
});
export const { useUploadImageMutation, useGetListProductsMutation, useSaveImportKPIMutation
    , useSaveImportSMSMutation, useSaveImportStatusMutation
 } = product;
export default product;